module.exports = __webpack_public_path__ + "static/media/logo-rocketseat.3fbf5a84.svg";